import script from "./Title.vue?vue&type=script&setup=true&lang=js"
export * from "./Title.vue?vue&type=script&setup=true&lang=js"

import "./Title.vue?vue&type=style&index=0&id=df85b46e&scoped=true&lang=less"

import exportComponent from "/var/www/tz-official-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-df85b46e"]])

export default __exports__